<template>
  <div>
    <el-dialog title="Initiate Refund Application" :close-on-click-modal="false" :visible.sync="visible" width="1200px" top="3vh">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top" v-loading="loading">
        <el-row :gutter="10">
          <el-col :span="24" class="pb16">
            <el-descriptions :column="3" size="medium" border :labelStyle="{ width: '130px' }">
              <el-descriptions-item>
                <span slot="label">Transaction No.</span>
                {{ detail.applymentNo || "" }}
              </el-descriptions-item>
              <el-descriptions-item>
                <span slot="label">Country</span>
                {{ detail.country || "" }}
              </el-descriptions-item>
              <el-descriptions-item>
                <span slot="label">Applicant Name</span>
                {{ detail.applicantName || "" }}
              </el-descriptions-item>
            </el-descriptions>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Refund Items" prop="refundInfoList">
              <div class="addBtnWrap">
                <el-button type="primary" icon="el-icon-plus" size="mini" plain @click="addOrUpdateHandle()">Add Item</el-button>
              </div>
              <el-table :data="dataForm.refundInfoList" size="medium" border class="wdb100 mt6">
                <el-table-column label="Description" prop="orderDescription" align="center" />
                <el-table-column label="Gov Fee" align="center" width="120">
                  <template slot-scope="scope">
                    <p class="orange">
                      {{ currencyAndAmountFormat(getBillingCurrency(scope.row.bankAccountIds, scope.row.invoiceTemplateId), scope.row.deductionAcraFee) }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column label="Handling Fee" align="center" width="120">
                  <template slot-scope="scope">
                    <p class="orange">
                      {{
                        currencyAndAmountFormat(getBillingCurrency(scope.row.bankAccountIds, scope.row.invoiceTemplateId), scope.row.deductionHandlingFee)
                      }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column label="Invoice Template" align="center">
                  <template slot-scope="scope">
                    <p>{{ invoiceTemplate(scope.row.invoiceTemplateId) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="Bank Accounts" align="center">
                  <template slot-scope="scope">
                    <p>{{ getBankAccountTags(scope.row.bankAccountIds, scope.row.invoiceTemplateId) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="Apply Reason" prop="applyReason" align="center" />
                <el-table-column label="Action" align="center" width="120px">
                  <template slot-scope="scope">
                    <el-button type="text" class="minWd0 mr10" @click="addOrUpdateHandle(scope.row, scope.$index)">Edit</el-button>
                    <el-button type="text" class="minWd0 red" @click="deleteHandle(scope.$index)">Delete</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Remark" prop="remark">
              <el-input
                v-model="dataForm.remark"
                type="textarea"
                :rows="5"
                :autosize="{ minRows: 4 }"
                resize="none"
                placeholder="Remark"
                v-regexFilter="halfWidthRegex"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Attachments" prop="attachmentUrls">
              <el-multiple-file-uploader v-model="dataForm.attachmentUrls"></el-multiple-file-uploader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" :disabled="loading" @click="dataFormSubmit">Submit</el-button>
      </span>
    </el-dialog>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      ref="addOrUpdate"
      :orderInfoList="detail.orderInfoList"
      :refundInfoList="dataForm.refundInfoList"
      :invoiceTemplateList="invoiceTemplateList"
      @refreshDataList="updateData"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./AddOrUpdate";
import formatterMixin from "@/mixins/formatterMixin";
import { mapActions } from "vuex";
export default {
  mixins: [formatterMixin],
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        applymentId: null,
        remark: "",
        attachmentUrls: [],
        refundInfoList: [],
      },
      dataRule: {
        refundInfoList: [{ type: "array", required: true, message: "please add", trigger: "submit" }],
      },
      invoiceTemplateList: [],
      submitLoading: false,
      loading: false,
    };
  },
  methods: {
    ...mapActions("applyment", ["doApplyRefundList", "initApplyment"]),
    // 初始化
    async init() {
      this.submitLoading = false;
      this.loading = true;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      await this.getInvoiceTemplateList();
      this.dataForm.applymentId = this.detail.id;
      this.loading = false;
    },
    // 新增 / 修改
    addOrUpdateHandle(row, index) {
      this.$refs.addOrUpdate.init(row, index);
    },
    // 删除
    deleteHandle(index) {
      this.dataForm.refundInfoList.splice(index, 1);
    },
    // 更新表格数据
    updateData(data, index) {
      if (index == null) {
        this.dataForm.refundInfoList.push(data);
      } else {
        this.dataForm.refundInfoList.splice(index, 1, data);
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.doApplyRefundList({
            ...this.dataForm,
          })
            .then(async () => {
              // 更新申请单详情
              await this.initApplyment(this.detail.id);
              this.$message({
                message: "success",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.visible = false;
                },
              });
            })
            .catch(msg => {
              this.submitLoading = false;
            });
        }
      });
    },
    // 获取发票模板列表
    getInvoiceTemplateList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/invoiceTemplate")
          .then(res => {
            const resData = res.data || [];
            // 仅保留退款发票(Credit Invoice)模板
            this.invoiceTemplateList = resData.filter(item => item.invoiceType == 2);
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 通过invoiceTemplate匹配相应信息
    invoiceTemplate(id) {
      if (id) {
        const templateName = this.invoiceTemplateList.find(item => item.id == id)?.templateName || "";
        return templateName;
      } else {
        return "";
      }
    },
    // 通过bankAccountIds匹配相应信息
    getBankAccountTags(selectedBankAccountIds, selectedInvoiceTemplateId) {
      if (selectedBankAccountIds?.length > 0) {
        // 获取选中发票模板下的银行账号列表
        const invoiceTemplateBankAccountList = this.invoiceTemplateList?.find(item => item.id == selectedInvoiceTemplateId)?.bankAccountList || [];
        // 通过选中的银行账户id匹配到银行账户信息
        const list = invoiceTemplateBankAccountList.filter(item => selectedBankAccountIds.includes(item.id));
        const tagList = list.map(item => item.tag) || [];
        return tagList.join(", ");
      } else {
        return "";
      }
    },
    // 通过bankAccountIds获取开票币种
    getBillingCurrency(selectedBankAccountIds, selectedInvoiceTemplateId) {
      // 获取选中发票模板下的银行账号列表
      const invoiceTemplateBankAccountList = this.invoiceTemplateList?.find(item => item.id == selectedInvoiceTemplateId)?.bankAccountList || [];
      // 第一个银行的币种作为开票币种
      const firstBankAccountId = selectedBankAccountIds[0];
      const currency = invoiceTemplateBankAccountList.find(item => item.id == firstBankAccountId)?.billingCurrency;
      return currency || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.addBtnWrap {
  text-align: right;
  margin-top: -32px;
}
</style>
